import React from 'react';

const themeContext = React.createContext({
  theme: {},
});

export default themeContext;